module.exports = __webpack_public_path__ + "img/letters.e5d423d9.svg";